<template>
    <div>
        <slot :open="open">
            <button class="button button--blank" type="button" @click="open">Manage Workers</button>
        </slot>
        <Modal v-if="show" no-max-width title="Manage workers" @close="hide">
            <PaginatedResource
                ref="workersResource"
                :fetch-method="fetchOrderWorkers"
                :page-size="20"
                :filter-fields="['order']"
                delay-fetch
            >
                <template #default="{ loading, sort, resource: workers, canLoadMore, loadMore }">
                    <div class="order-manage-workers">
                        <div class="order-manage-workers__list">
                            <div>
                                <Spinner v-if="loading" />
                                <OrderManageWorkersTable
                                    :loading="loading"
                                    :order="order"
                                    :workers="workers"
                                    @workerRemove="refetchWorkers"
                                    @sort="sort"
                                />
                                <div v-if="canLoadMore" class="order-manage-workers__loadmore">
                                    <button
                                        class="button button--big button--blank"
                                        type="button"
                                        @click="loadMore"
                                    >
                                        {{ $t('misc.loadmore') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="order-manage-workers__add">
                            <OrderManageWorkersAdd
                                v-if="order.permissions.create_worker"
                                :order="order"
                                :workers="workers"
                                @create="refetchWorkers"
                            />
                        </div>
                    </div>
                </template>
            </PaginatedResource>
        </Modal>
    </div>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import Spinner from '@speechki-frontend/shared/ui/Spinner';

import { fetchOrderWorkers } from '../../api/workers';

import OrderManageWorkersTable from './OrderManageWorkersTable';
import OrderManageWorkersAdd from './OrderManageWorkersAdd';

export default {
    name: 'OrderManageWorkers',
    components: {
        Modal,
        PaginatedResource,
        Spinner,

        OrderManageWorkersTable,
        OrderManageWorkersAdd,
    },
    props: {
        order: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            orderWorker: undefined,
            show: false,
        };
    },

    methods: {
        fetchOrderWorkers,

        // public
        async open() {
            this.show = true;
            this.loading = true;

            await this.$nextTick();

            await this.fetchWorkersResource();

            this.loading = false;
        },
        hide() {
            this.show = false;
        },

        async fetchWorkersResource() {
            await this.$refs.workersResource.filter({ order: this.order.id });
        },
        async refetchWorkers() {
            this.loading = true;
            this.fetchWorkersResource();
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" src="./OrderManageWorkers.scss"></style>
